module.exports = __webpack_public_path__ + "img/erp-logos_0001_zoho.6c683975.jpg";